// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOffer {
  /** Realty ID объявления **/
  realtyId: number;
  /** Cian ID объявления **/
  cianId: number;
  /** Средняя цена за сутки **/
  averagePricePerDay: number;
  /** Объявление уже просмотрено пользователем **/
  isViewed: boolean;
  /** Объявление находится в избранном у пользователя **/
  isFavorite: boolean;
  /** Возможно онлайн бронирование **/
  hasOnlineBooking: boolean;
  /** Иконка **/
  icon?: TOffer_Icon;
  /** Данные для автотестов **/
  testData?: TOffer_TestData;
}

export type TOffer_Icon = null | EIcon;

export enum EIcon {
  /** Молния **/
  'Bolt' = 'bolt',
  /** Иконка для скидок **/
  'Discount' = 'discount',
}
export type TOffer_TestData = null | TOffer_TestData_1;

export type TOffer_TestData_1 = object;
